import { Address } from '@dreryk/address-common-api';
import { VisitLocation } from '@dreryk/egabinet-visit-frontend-api';

export enum VisitLocationType {
   SERVICE_PROVIDING_LOCATION = 'serviceProvidingLocation',
   FACILITY_LOCATION = 'facilityLocation',
   FACILITY_UNIT = 'facilityUnit',
}

export type VisitLocationId = {
   id: number;
   type: VisitLocationType;
};

export type VisitLocationData = {
   id: number;
   name: string;
   type: VisitLocationType;
   address: Address;
};

export type VisitLocationSelector = VisitLocation;
